'use strict';

require("core-js/modules/es.array.reduce");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = createActions;

var _immutable = require('immutable');

var _isoFetchStream = require('iso-fetch-stream');

var _isoFetchStream2 = _interopRequireDefault(_isoFetchStream);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _methods = require('./methods');

var _methods2 = _interopRequireDefault(_methods);

var _log = require('../lib/log');

var _query_string = require('../lib/query_string');

var _query_string2 = _interopRequireDefault(_query_string);

var _make_empty = require('../lib/make_empty');

var _make_empty2 = _interopRequireDefault(_make_empty);

var _schema = require('../lib/schema');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var propsList = ['url', 'credentials', 'authorization', 'onSuccess', 'onError', 'immutable'];
var actionsCache = {};

var methodizeResource = function methodizeResource(fetch, props) {
  return function (memo, key) {
    var serializedKey = [].concat(propsList, [key]).reduce(function (memo, key) {
      return memo + ('&' + key + '=' + String(props[key]));
    }, '');

    if (actionsCache[serializedKey]) {
      memo[key] = actionsCache[serializedKey];
    } else {
      var url = props.url;
      var schema = (0, _schema.getSchema)(props[key]);
      var options = _typeof(props[key]) === 'object' ? props[key] : {};
      var useImmutable = props.immutable || options.immutable;
      var resourceType = schema.title;
      var resourcePath = '/' + resourceType; // initial the main export for use in other modules

      var main = {}; // api-specific helpers for working with the state tree

      var apiStore = (0, _store2.default)(url, schema); // set up all routes

      var _configureRoutes = (0, _routes2.default)(key, resourcePath, options, main),
          getRouteConfig = _configureRoutes.getRouteConfig,
          isCustomRoute = _configureRoutes.isCustomRoute; // xhr + fetch state helpers


      var api = (0, _methods2.default)(fetch, apiStore, getRouteConfig); // placeholder to return while cacheable fetches are pending

      var getPlaceholder = function getPlaceholder(promise) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var dataType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _immutable.List;
        return {
          promise: promise,
          data: useImmutable ? (0, _make_empty2.default)(dataType) : dataType().toJS(),
          isPending: true,
          error: path ? apiStore.getError(path) : null,
          clear: function clear() {
            return undefined;
          },
          reset: function reset() {
            return Promise.reject('no data to reset');
          }
        };
      };

      var deliver = function deliver(structure) {
        return !useImmutable && (typeof structure === 'undefined' ? 'undefined' : _typeof(structure)) === 'object' && structure.toJS ? structure.toJS() : structure;
      }; // LIST


      var $list = function $list(params) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _getRouteConfig = getRouteConfig('list', params),
            route = _getRouteConfig.route;

        var path = route + (params ? '?' + (0, _query_string2.default)(params) : '');
        var collection = apiStore.getCollection(path);

        if (options.reset || !collection) {
          var promise = api.fetchAll(path);
          return getPlaceholder(promise, path);
        } else {
          var clear = function clear() {
            return apiStore.clearCollection(path);
          };

          return {
            data: deliver(collection).map(_addRestMethods),
            promise: apiStore.getRequestsPromise(route),
            clear: clear,
            reset: function reset() {
              clear();
              $list(params);
            }
          };
        }
      }; // SEARCH


      var $search = function $search(params) {
        var _getRouteConfig2 = getRouteConfig('search', params),
            method = _getRouteConfig2.method,
            route = _getRouteConfig2.route,
            onSuccess = _getRouteConfig2.onSuccess,
            onError = _getRouteConfig2.onError;

        var fullRoute = method === 'get' ? route + ('?' + (0, _query_string2.default)(params)) : route;

        if (api.shouldFetch(fullRoute)) {
          var promise = method === 'get' ? api.get(fullRoute) : api[method](fullRoute, params);
          return promise.then(onSuccess).then(function (data) {
            apiStore.setCollection(data, fullRoute);
            return data;
          }).catch(onError);
        } // TODO: store promise as pending value so it can be used on repeat
        // calls


        return Promise.resolve('pending');
      };

      $search.results = function (params) {
        var _getRouteConfig3 = getRouteConfig('search', params),
            route = _getRouteConfig3.route,
            method = _getRouteConfig3.method;

        var fullRoute = method === 'get' ? route + ('?' + (0, _query_string2.default)(params)) : route;
        var collection = apiStore.getCollection(fullRoute);
        var promise = apiStore.getRequestsPromise(fullRoute);

        if (collection) {
          var clear = function clear() {
            return apiStore.clearCollection(fullRoute);
          };

          return {
            data: deliver(collection).map(_addRestMethods),
            promise: promise,
            clear: clear,
            reset: function reset() {
              clear();
              $search(params);
            }
          };
        } else {
          var placeholder = getPlaceholder(promise, fullRoute);
          placeholder.isPending = !!apiStore.getPending(fullRoute);
          return placeholder;
        }
      }; // CREATE


      var optimisticCreate = function optimisticCreate(data) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (typeof options.optimistic === 'function') {
          var nextState = apiStore.getState().withMutations(function (map) {
            return options.optimistic(map, data);
          });
          if (nextState) apiStore.setState(nextState);
          return api.createOne(data, options);
        } else {
          (0, _log.logWarn)('Optimistic creates must receive a function that updates the state with the optimistic data. The create will proceed pessimistically.');
          return api.createOne(data, options);
        }
      };

      var $create = function $create(data) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return !options.optimistic ? api.createOne(data, options) : optimisticCreate(data, options);
      }; // GET


      var $get = function $get(id) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var model = apiStore.getModel(id);

        var _getRouteConfig4 = getRouteConfig('get', id),
            route = _getRouteConfig4.route;

        if (options.reset || !model || !model.get('_fetched')) {
          var promise = api.fetchOne(id);
          var placeholder = getPlaceholder(promise, route, _immutable.Map);
          placeholder.delete = _$delete(id);
          placeholder.update = _$update(id);
          return placeholder;
        } else {
          return _extends({}, _addRestMethods(deliver(model)), {
            promise: apiStore.getRequestsPromise(route)
          });
        }
      }; // DELETE


      var optimisticDelete = function optimisticDelete(id) {
        var undoDelete = apiStore.deleteModel(id);

        if (undoDelete.length) {
          return api.deleteOne(id).catch(function (err) {
            (0, _log.logError)('Failed to delete ' + id, err);
            undoDelete.forEach(function (undo) {
              return undo();
            });
            return Promise.reject(err);
          });
        } else {
          return Promise.reject(new Error(404));
        }
      };

      var _$delete = function _$delete(id) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return options.optimistic === false || !apiStore.getModel(id) ? api.deleteOne(id).then(function (response) {
            apiStore.deleteModel(id);
            return response;
          }) : optimisticDelete(id);
        };
      }; // UPDATE


      var optimisticUpdate = function optimisticUpdate(id, vals) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var placeholder = typeof options.optimistic === 'function' ? options.optimistic(_extends({
          id: id
        }, vals)) : vals;
        var undoUpdate = apiStore.updateModel(id, placeholder);

        if (undoUpdate.length) {
          return api.updateOne(id, vals).then(function (response) {
            apiStore.updateModel(id, response);
            return response;
          }).catch(function (err) {
            (0, _log.logError)('Failed to update ' + id + ' with vals', vals, err);
            undoUpdate.forEach(function (undo) {
              return undo();
            });
            return Promise.reject(err);
          });
        } else {
          return Promise.reject(new Error(404));
        }
      };

      var _$update = function _$update(id) {
        return function (vals) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return options.optimistic === false || !apiStore.getModel(id) ? api.updateOne(id, vals).then(function (response) {
            apiStore.updateModel(id, response);
            return response;
          }) : optimisticUpdate(id, vals, options);
        };
      }; // CACHE management for models


      var $clear = function $clear(id) {
        return function () {
          return apiStore.setModel(id, null);
        };
      };

      var $reset = function $reset(id) {
        return function () {
          return api.fetchOne(id);
        };
      };

      var _addRestMethods = function _addRestMethods(model) {
        if ((typeof model === 'undefined' ? 'undefined' : _typeof(model)) === 'object') {
          var id = (0, _schema.getIdFromModel)(model);
          return {
            data: model,
            delete: _$delete(id),
            update: _$update(id),
            clear: $clear(id),
            reset: $reset(id)
          };
        }

        return model;
      };

      main.list = $list;
      main.search = $search;
      main.create = $create;
      main.get = $get;
      main.clearAll = apiStore.clearAll;
      main.reset = api.fetchAll;
      main.subscribePath = apiStore.subscribePath;
      main.getState = apiStore.getState; // hang standard api methods off of .api so devs can construct
      // non-standard paths

      main.api = ['delete', '$get', 'get', 'post', 'put', 'stream'].reduce(function (memo, method) {
        return _extends({}, memo, _defineProperty({}, method, function (path) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var route = resourcePath + path;

          if (method === '$get') {
            var cache = apiStore.getRequestsData(route);
            var promise = apiStore.getRequestsPromise(route);

            if (cache) {
              return {
                promise: promise,
                data: _immutable.List.isList(cache) ? deliver(apiStore.getCollection(route)).map(_addRestMethods) : deliver(cache)
              };
            } else {
              if (api.shouldFetch(route)) {
                promise = api.get.apply(api, [route].concat(args)).then(function (data) {
                  if (Array.isArray(data)) {
                    apiStore.setCollection(data, route);
                  } else {
                    apiStore.setRequestsData(route, data);
                  }

                  return data;
                });
              }

              return getPlaceholder(promise, route);
            }
          } else {
            return api[method].apply(api, [route].concat(args));
          }
        }));
      }, {}); // add custom methods specified by user in routes config

      var fetchCacheable = function fetchCacheable(config) {
        var cache = deliver(apiStore.getRequestsData(config.route));
        var promise = apiStore.getRequestsPromise(config.route);

        if (cache) {
          var clear = function clear() {
            return apiStore.setRequestsData(config.route, null);
          };

          return {
            clear: clear,
            data: cache,
            promise: promise,
            reset: function reset() {
              cache.$clear();
              api.custom(config);
            }
          };
        } else {
          if (api.shouldFetch(config.route)) {
            promise = api.custom(config);
          }

          return getPlaceholder(promise, config.route);
        }
      };

      var fetchNonCacheable = function fetchNonCacheable(config) {
        return api[config.method](config.route, config.body).then(config.onSuccess, config.onError);
      };

      Object.keys(options.routes || {}).forEach(function (key) {
        if (isCustomRoute(key)) {
          main['' + key] = function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            var config = getRouteConfig.apply(undefined, [key].concat(args));
            return config.usesCache ? fetchCacheable(config) : fetchNonCacheable(config);
          };
        }
      });
      actionsCache[serializedKey] = memo[key] = main;
    }

    return memo;
  };
};

function createActions(props) {
  var fetchOptions = props.credentials ? {
    credentials: props.credentials
  } : {};

  if (props.auth || props.authorization) {
    fetchOptions.headers = {
      Authorization: props.auth || props.authorization
    };
  }

  fetchOptions.makeUrl = function (path) {
    return props.url + path;
  };

  var fetch = (0, _isoFetchStream2.default)(fetchOptions);
  return Object.keys(props).filter((0, _schema.isSchema)(props)).reduce(methodizeResource(fetch, props), {});
}